import React from 'react';

import { Box, Button, Divider, Icon } from '@rbilabs/universal-components';
import { Typography } from 'ucl/components/text/Typography';

import { CopyButton, DebugToolModal, PluInfo, useDebugToolPosVendor } from 'components/debug-tool';
import { MenuObjectTypes } from 'enums/menu';
import useFoodware from 'hooks/use-foodware';
import { findVendorConfig } from 'utils/vendor-config';

import { getSanityDocumentUrl } from '../utils';

const FoodwareDebugModal: React.FC<{
  onClose: () => void;
}> = ({ onClose }) => {
  const { storePosVendor } = useDebugToolPosVendor();
  const { featureFoodware } = useFoodware();

  return (
    <DebugToolModal onOpenEventMessage="Menu Debug Tool: Foodware" onClose={onClose}>
      <Box marginY="$4">
        <Typography variant="headerOne">Selected Product:</Typography>
        {featureFoodware?.items ? (
          featureFoodware.items.map(foodware => {
            const { name, _id, vendorConfigs } = foodware || {};
            if (name && _id && vendorConfigs) {
              const vendorConfig = findVendorConfig(vendorConfigs, storePosVendor);
              return (
                <React.Fragment key={_id}>
                  <CopyButton
                    label={name?.locale ?? ''}
                    textToCopy={getSanityDocumentUrl(MenuObjectTypes.ITEM, _id)}
                    variant="headerTwo"
                  />
                  {vendorConfig && <PluInfo vendorConfig={vendorConfig} />}
                  <Divider />
                </React.Fragment>
              );
            }
            return (
              <Typography variant="headerTwo" key={_id}>
                Error: Encountered null or missing properties when parsing foodware
              </Typography>
            );
          })
        ) : (
          <Typography variant="headerTwo">No foodware items found.</Typography>
        )}
      </Box>
    </DebugToolModal>
  );
};

export const FoodwareDebug = () => {
  const [isDebugMenuModalOpen, setIsDebugMenuModalOpen] = React.useState(false);

  return (
    <>
      <Button
        variant="ghost"
        onPress={() => setIsDebugMenuModalOpen(true)}
        leftIcon={<Icon name="mi:bug-report" />}
      >
        <Typography>View Foodware info</Typography>
      </Button>

      {isDebugMenuModalOpen && (
        <FoodwareDebugModal onClose={() => setIsDebugMenuModalOpen(false)} />
      )}
    </>
  );
};
